import React from "react";
import { LeftSidebar } from "./LeftSidebar";
import { Header } from "./Header";

interface SidebarLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
}

export function SidebarLayout({ children, sidebar }: SidebarLayoutProps) {
  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-50/50">
      <div className="flex-shrink-0">
        <Header />
      </div>
      <div className="flex flex-col lg:flex-row flex-1 w-full bg-white shadow-sm border-x border-slate-200/50 overflow-hidden lg:pt-4 pb-3">
        {/* Below lg the sidebar stacks above the content as a collapsible
            dropdown (see the sidebar components) instead of squeezing it into a
            narrow icon rail; at lg+ it's the 280px labeled rail. */}
        <div className="w-full lg:w-[280px] flex-shrink-0 border-b lg:border-b-0 lg:border-r border-slate-100 bg-white lg:h-full">
          {sidebar ?? <LeftSidebar />}
        </div>
        <main className="flex-1 min-w-0 w-full bg-white overflow-y-auto mt-4">
          {children}
        </main>
      </div>
    </div>
  );
}
